// Definición de paletas de colores para modo claro y oscuro

export const lightTheme = {
  background: '#f5f5f5',
  text: '#222222',
  primary: '#4a90e2',
  secondary: '#764ba2',
  link: '#0077cc',
  linkHover: '#005fa3',
  headerBg: '#4a90e2',
  headerText: '#ffffff',
  footerBg: '#222222',
  footerText: '#cccccc',
  buttonBg: '#4a90e2',
  buttonText: '#ffffff',
};

export const darkTheme = {
  background: '#121212',
  text: '#e0e0e0',
  primary: '#90caf9',
  secondary: '#ce93d8',
  link: '#82b1ff',
  linkHover: '#448aff',
  headerBg: '#1f1f1f',
  headerText: '#ffffff',
  footerBg: '#1f1f1f',
  footerText: '#888888',
  buttonBg: '#90caf9',
  buttonText: '#121212',
};
